<template>
  <div class="rm-layout-main">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AppMain'
}
</script>

<style lang="scss" scoped>
.rm-layout-main {
  /* 高度自适应内容，不设 min-height */
}
</style>
